import React, { useState, useEffect } from 'react';
import { Container, Button } from 'react-bootstrap';
import { FaStore, FaBoxes, FaUsers } from 'react-icons/fa';
import '../../../../assets/css/user/home/subscreens/vendorprogram/VendorProgram.css';

const VendorProgram = () => {
  const [activeCard, setActiveCard] = useState(1); // Start from center (index 1)

  // Auto-sliding effect: 0 -> 1 -> 2 -> 0
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveCard((prev) => (prev + 1) % 3);
    }, 4000); // Har 4 seconds mein slide hoga

    return () => clearInterval(interval);
  }, []);

  const cardsData = [
    {
      id: 1,
      icon: <FaBoxes className="vendor-card-icon" />,
      title: "Rental Management System",
      description: "Easily manage your equipment inventory, bookings, and availability from a single platform. Get real-time updates and automated alerts for scheduling and stock management. Streamline your rental operations for better efficiency and control.",
      badge: null
    },
    {
      id: 2,
      icon: <FaStore className="vendor-card-icon" />,
      title: "Start Your Business",
      description: "Register as a vendor and list your agricultural machinery to reach a wide network of farmers. Expand your business with flexible pricing and easy management tools. Grow your presence and increase earnings through a digital platform.",
      button: "Register Now",
      
      badge: "VENDOR PROGRAM"
    },
    {
      id: 3,
      icon: <FaUsers className="vendor-card-icon" />,
      title: "Customer Analytics & Insights",
      description: "Gain valuable insights into farmer demand, seasonal trends, and equipment usage patterns. Analyze booking data and performance reports to understand market needs. This helps vendors make informed decisions and improve service quality.",
      badge: null
    }
  ];

  // Calculate positions for carousel effect
  const getCardPosition = (index) => {
    const diff = index - activeCard;
    if (diff === 0) return 'center';
    if (diff === -1 || diff === 2) return 'left';
    if (diff === 1 || diff === -2) return 'right';
    return '';
  };

  return (
    <section className="vendor-program-section">
      {/* Animated Bubbles Background - Full Section */}
      <div className="bubbles-container">
        <div className="bubble bubble-1"></div>
        <div className="bubble bubble-2"></div>
        <div className="bubble bubble-3"></div>
        <div className="bubble bubble-4"></div>
        <div className="bubble bubble-5"></div>
        <div className="bubble bubble-6"></div>
        <div className="bubble bubble-7"></div>
        <div className="bubble bubble-8"></div>
        <div className="bubble bubble-9"></div>
        <div className="bubble bubble-10"></div>
      </div>

      <Container>
        {/* Header Section */}
        <div className="vendor-header text-center mb-5">
          <div className="vendor-badge mb-3">
            VENDOR PROGRAM
          </div>
          <h1 className="vendor-main-heading">
            Grow Your Agricultural Legacy
          </h1>
          <p className="vendor-subheading">
            Join our elite vendor community and reach thousands of farmers and retail buyers instantly. Scale your business with our professional tools.
          </p>
        </div>

        {/* Carousel Cards Section */}
        <div className="vendor-carousel-container">
          <div className="vendor-carousel">
            {cardsData.map((card, index) => {
              const position = getCardPosition(index);
              const isActive = activeCard === index;
              
              return (
                <div
                  key={card.id}
                  className={`vendor-card-wrapper ${position}`}
                  onClick={() => setActiveCard(index)}
                >
                  <div className={`vendor-card ${isActive ? 'active' : ''}`}>
                    <div className="vendor-card-icon-wrapper">
                      {card.icon}
                    </div>

                    <h3 className="vendor-card-title">{card.title}</h3>
                    
                    <p className="vendor-card-description">
                      {card.description}
                    </p>

                    {/* Button (Only for center/active card) */}
                    {/* {card.button && isActive && (
                      <Button className="vendor-register-btn">
                        {card.button} <span className="btn-arrow">→</span>
                      </Button>
                    )} */}

                    {/* Avatars (Only for center/active card) */}
                    {card.avatars && isActive && (
                      <div className="vendor-avatars mt-3">
                        <div className="avatar-group">
                          <img 
                            src="https://i.pravatar.cc/40?img=1" 
                            alt="User 1" 
                            className="avatar"
                          />
                          <img 
                            src="https://i.pravatar.cc/40?img=2" 
                            alt="User 2" 
                            className="avatar"
                          />
                          <img 
                            src="https://i.pravatar.cc/40?img=3" 
                            alt="User 3" 
                            className="avatar"
                          />
                        </div>
                        {/* <span className="avatar-text">2.4k active shopkeepers</span> */}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Pagination Dots */}
        <div className="vendor-pagination">
          {[0, 1, 2].map((dot) => (
            <span
              key={dot}
              className={`pagination-dot ${activeCard === dot ? 'active-dot' : ''}`}
              onClick={() => setActiveCard(dot)}
            />
          ))}
        </div>
      </Container>
    </section>
  );
};

export default VendorProgram;